import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../services/data.service';

@Component({
	selector: 'app-my-profile',
	imports: [CommonModule, FormsModule],
	providers: [DatePipe],
	templateUrl: './my-profile.component.html',
	styleUrl: './my-profile.component.scss',
})
export class MyProfileComponent {
	user: any = null;

	base = 'users';		// important for API calls
  loading = false;

	frmData: any = {
		display_name: '',
		user_name: '',
		desi_dept: '',
		mobile_no: '',
		email_id: ''
	};

	frmChPW: any = {
		old_pw: '',
		new_pw: '',
		cnf_pw: ''
	}

	constructor(
		public dataService: DataService
	) {
		//
	}

	ngOnInit() {
		let erp_rem: any = localStorage.getItem("erp_rem");
		if(erp_rem) {
			erp_rem = JSON.parse(erp_rem);
			erp_rem = this.dataService.deCodeUser(erp_rem);
			this.user = erp_rem;
			
			this.frmData = {
				display_name: this.user.display_name,
				user_name: this.user.user_name,
				desi_dept: this.user.desi_dept,
				mobile_no: this.user.mobile_no,
				email_id: this.user.email_id
			}
		}
	}

  doUpdate() {
    this.loading = true;
		const myid = this.user.id;

		this.dataService.updateRecord('update_profile', myid, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        // this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  pwUpdate() {
    this.loading = true;
		const myid = this.user.id;

		this.dataService.updateRecord('change_pw', myid, this.frmChPW).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        // this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }


}
